import React from 'react';
import { motion } from 'framer-motion';
import { Syringe, Sparkles, Droplets, HeartPulse, Dna, Activity } from 'lucide-react';
const treatments = [{
  icon: Syringe,
  name: 'Botox',
  description: 'Suaviza arrugas con resultados naturales'
}, {
  icon: Sparkles,
  name: 'Láser',
  description: 'Tecnología de punta para tu piel'
}, {
  icon: Droplets,
  name: 'PRP',
  description: 'Rejuvenecimiento con tu propia biología'
}, {
  icon: HeartPulse,
  name: 'Skin Quality',
  description: 'Hidratación y luminosidad profunda'
}, {
  icon: Activity,
  name: 'Antiaging Médico',
  description: 'Protocolos científicos anti-edad'
}, {
  icon: Dna,
  name: 'PDRN',
  description: 'Regeneración celular de nueva generación'
}];
export function Treatments() {
  return <section id="tratamientos" className="py-24 bg-ivory" data-id="element-175">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-176">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-177">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal mb-4" data-id="element-178">
            Nuestros Tratamientos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-charcoal/70 text-lg" data-id="element-179">
            Cada procedimiento está diseñado para resaltar tu belleza de forma
            segura, natural y personalizada.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-180">
          {treatments.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group bg-white p-8 rounded-2xl shadow-soft hover:shadow-soft-lg border border-transparent hover:border-rosegold/30 transition-all duration-300 flex flex-col h-full" data-id="element-181">
              <div className="bg-rosegold/10 w-14 h-14 rounded-full flex items-center justify-center text-rosegold mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-182">
                <t.icon size={28} strokeWidth={1.5} data-id="element-183" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-charcoal mb-3" data-id="element-184">
                {t.name}
              </h3>
              <p className="text-charcoal/60 mb-6 flex-grow" data-id="element-185">{t.description}</p>
              <a href="#reservar" className="text-rosegold font-medium text-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" data-id="element-186">
                Conocer más <span aria-hidden="true" data-id="element-187">→</span>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}